<template>
  <b-card>
    <div slot="header">
      <h4 class="mr-5 pull-left">{{$t('RECOMMENDATIONS')}}</h4>
      <new-button button_type="new" variant="primary" class="pull-right" @click="addNew">
       {{$t('NEW_RECOMMENDATION')}}
      </new-button>
    </div>
    <app-aside  :widths="['col-sm-12', '40%']"   v-model="aside">
      <confirmation-dialog :message="$t('DELETE_RECOMMENDATION_MSG')" :show="showDeleteDialog" @confirm="deleteItem" @cancel="showDeleteDialog=false"> </confirmation-dialog>
      <template slot="header">
        <div v-if="editObject">
          {{$t('EDIT_RECOMMENDATION')}}

        </div>
        <div v-else>
          {{$t('NEW_RECOMMENDATION')}}
        </div>
      </template>
      <template v-slot:activation v-if="editObject && editObject.header_id">
        <DeleteButton @click="showDeleteDialog=true">
          {{$t('DELETE_RECOMMENDATION')}}
        </DeleteButton>
      </template>
      <br/>
      <RecommendationLanguageWrapper :onlyRead="false"  @success="search" :header="editObject"/>
      <br/>
    </app-aside>
    <div class="position-relative">
      <form class="mb-4" @submit.prevent="search" @reset.prevent="resetForm">
        <b-row>
          <b-col lg="2" md="3" sm="12" >
            <label class="label-text">{{$t('YEAR')}}</label>
            <multiselect
              placeholder="-"
              :selectedLabel="$t('SELECTED')"
              :selectLabel="$t('APPLY')"
              :deselectLabel="$t('CLEAR')"
              v-model="filter.year" :options="year_options" label="text" track-by="value"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <label class="label-text">{{$t('DOMAIN')}}</label>
            <multiselect
              placeholder="-"
              :selectedLabel="$t('SELECTED')"
              :selectLabel="$t('APPLY')"
              :deselectLabel="$t('CLEAR')"
              v-model="filter.domain" :options="domains" label="name" track-by="id"/>
          </b-col>
          <b-col lg="3" md="4" sm="12">
            <label class="label-text">{{$t('COMPLETION_STATUS')}}</label>
            <multiselect
              placeholder="-"
              :selectedLabel="$t('SELECTED')"
              :selectLabel="$t('APPLY')"
              :deselectLabel="$t('CLEAR')"
              v-model="filter.status_complete" :options="statusOptions" label="name" track-by="id"/>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="d-inline-flex">
            <app-submit :disabled="loading" :loading="loader_submit" class="mr-3" variant="primary"  button_type="search"> {{$t('SEARCH')}}</app-submit>
            <app-submit :disabled="loading" :loading="loader_reset" class="mr-3" variant="outline-primary" type="reset" button_type="reset">{{$t('RESET')}}</app-submit>
          </b-col>
        </b-row>
      </form>
      <div v-if="items && items.length > 0" class="table-container">
        <b-table class="applicant_table animated fadeIn"  responsive hover  :tbody-tr-class="rowClass" :fields="fields" :items="items" primary-key="id" :busy="loading">
          <template v-slot:cell(num)="data">
            {{ (currentPage - 1) * perPage + data.index + 1 }}
          </template>
          <template v-slot:cell(indicator)="data">
            <div v-html="data.item.indicator"></div>
          </template>
          <template v-slot:cell(recommendation)="data">
            <div v-html="data.item.recommendation"></div>
          </template>
          <template v-slot:cell(goal)="data">
            <div v-html="data.item.goal"></div>
          </template>
          <template v-slot:cell(competent_authorities)="data">
            <span v-for="(competentAuthority, index) in data.item.competent_authorities">
              {{competentAuthority.name}}<span v-if="
              showComa(data.item.competent_authorities, index)">,</span>
            </span>
          </template>
          <template v-slot:cell(competent_organ)="data">
            {{data.item.competent_organ.toString()}}
          </template>
          <template v-slot:cell(edit)="data">
            <app-button class="pull-right"
                        @click="edit(data.item)"
                        size="sm"
                        variant="link">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </app-button>
          </template>
          <template v-slot:cell(status)="data">
              <AppIndicator v-b-tooltip.hover :title="indicatorTooltip(data.item.status_complete)" :indicator_type="indicatorType(data.item.status_complete)"/>
          </template>
        </b-table>
        <b-pagination
          size="sm"
          :prev-text="$t('PREV')"
          :next-text="$t('NEXT')"
          :total-rows="total"
          :per-page="perPage"
          v-model="currentPage">
        </b-pagination>
      </div>
    </div>
  </b-card>
</template>

<script>
import AppAside from '@/components/app/form/AppAside'
import NewButton from '@/components/app/AppButton'
import AppButton from "@/components/app/AppButton";
import routeNames from '@/router/routeNames'
import {formatDate, formatDateTime, formatDecimals} from '@/filters/formatDates';
import AppSubmit from "@/components/app/AppSubmit";
import { mapGetters } from 'vuex';
import {toast} from "@/shared/plugins/toastr";
import {getErrorMessage} from "@/mixins/error/getErrorMessage";
import {
  activateRecommendation,
  deactivateRecommendation,
  deleteRecommendation,
  getRecommendationList
} from "@/services/reccommendation";
import RecommendationForm from "@/components/recommendation/RecommendationForm.vue";
import AppIndicator from "@/components/app/AppIndicator.vue";
import Multiselect from "vue-multiselect";
import RecommendationLanguageWrapper from "@/components/recommendation/RecommendationLanguageWrapper.vue";
import DeleteButton from "@/components/app/AppDelete.vue";
import ConfirmationDialog from "@/components/app/form/AppConfirmationDialog.vue";
export default {
  name: "index",
  mixins: [getErrorMessage],
  data(){
    return {
      fields: [
        {key: 'num', label: 'Rb'},
        {key: 'domain.name', label: this.$t('DOMAIN')},
        {key: 'recommendation', label: this.$t('RECOMMENDATIONS')},
        {key: 'competent_authorities', label: this.$t('COMPETENT_ORGAN')},
        {key: 'specific_recommendation', label: this.$t('SPECIFIC_RECOMMENDATION')},
        {key: 'indicator', label: this.$t('INDICATOR')},
        {key: 'goal', label: this.$t('GOAL')},
        {key: 'status', label: ''},
        {key: 'edit', label: ''}
      ],
      editAsidePanelState: false,
      currentPage: 1,
      listCount: 100,
      perPage: 5,
      total: 0,
      loading: false,
      routeNames,
      aside: false,
      editAside: false,
      filter: {
        year: null,
        domain: null,
        status_complete: null,
      },
      type_options: [
        {value: null, text: '-'},
        { value: 1, text: 'Kupovina' },
        { value: 2, text: 'Prodaja' },
      ],
      statusOptions: [
        {id: 1, name: this.$t('NOT_FULFILLED')},
        {id: 2, name: this.$t('PARTIALLY_FULFILLED')},
        {id: 3, name: this.$t('FILLED')},
      ],
      year_options: [
        {value: 2023, text: '2023'},
        {value: 2022, text: '2022'},
        {value: 2021, text: '2021'},
      ],
      loader_submit: false,
      loader_reset: false,
      loader_activate: false,
      loader_deactivate: false,
      items: [],
      editObject: {},
      showDeleteDialog: false,
    }
  },
  components:{
    ConfirmationDialog,
    DeleteButton,
    RecommendationLanguageWrapper,
    Multiselect,
    AppIndicator,
    NewButton,
    AppAside,
    AppButton,
    AppSubmit,
    RecommendationForm
  },
  filters:{
    formatDate,
    formatDecimals,
    formatDateTime
  },
  methods: {
    activate(id) {
      this.loader_activate = true;
      activateRecommendation(id).then(() => {
        this.closeAndReload();
      }, (error) => {
        toast({
          'title': "Greška",
          'message': this.getMessages(error),
          'type': 'error',
          'timeout': 6000
        })
      }).finally(() => {
        this.loader_activate = false;
      })
    },
    deleteItem() {
      deleteRecommendation(this.editObject.header_id).then(() => {
        this.showDeleteDialog = false;
        this.aside = false
        this.search();
      })
    },
    deactivate(id) {
      this.loader_deactivate = true;
      deactivateRecommendation(id).then(() => {
        this.closeAndReload();
      }, (error) => {
        toast({
          'title': "Greška",
          'message': this.getMessages(error),
          'type': 'error',
          'timeout': 6000
        })
      }).finally(() => {
        this.loader_deactivate = false;
      })
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.translation_not_complete === true) return 'table-lang-not-complete'
    },
    indicatorType(status){
        if(status === 1) {
          return 'indicator-danger'
        }
        if(status === 2) {
          return 'indicator-warning';
        }
        if(status === 3) {
          return 'indicator-success'
        }
    },
    indicatorTooltip(status) {
      const indicatorObject = this.statusOptions.find((el) => el.id === status);
      if(indicatorObject && indicatorObject.name) {
        return indicatorObject.name
      }
      return  null
    },
    closeAndReload() {
        this.aside = false;
        this.editAside = false;
        this.editId = null;
        this.search();
    },
    edit(recommendation){
      this.aside = true;
      this.editObject = recommendation;
    },
    addNew() {
      this.aside = true;
      this.editObject = null;
    },
    showComa(competent_authorities, index){
      return competent_authorities.length > 1 && index !== (competent_authorities.length - 1)
    },
    search() {
      this.loading = true;
      const request = {
        year: this.filter.year ? this.filter.year.value : null,
          domain: this.filter.domain ? this.filter.domain.id : null,
          status_complete: this.filter.status_complete ? this.filter.status_complete.id : null,
          limit: this.perPage,
          page: this.currentPage
        }
      getRecommendationList(request).then((response) => {
        this.items = response.data.items
        this.total = response.data.total
        this.currentPage = response.data.page
      }, (error) => {
        toast({
          'title': "Greška",
          'message': this.getMessages(error),
          'type': 'error',
          'timeout': 6000
        })
      }).finally(() => {
        this.loading = false
      })
    },
    resetForm(){
      this.filter = {
        year: null,
        domain: null,
        status_complete: null,
      }
      this.perPage = 5;
      this.currentPage = 1;
      this.search();
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.search();
      }
    },
  },
  computed: {
    ...mapGetters('user', ['currentLanguage']),
    domains() {
      return this.$store.getters['recommendation/domains']
    }
  },
  mounted() {
    this.search();
  }
}
</script>

<style scoped>

</style>
